import { handleActions } from 'redux-actions';
import { getTestimonialTemplatesAction, getTestimonialsAction, setLoaderTestimonial } from 'actions/testimonials';

const initialState = {
  testimonials: [],
  testimonialTemplates: [],
  testimonialLoader: false,
};

const testimonialsReducer = handleActions(
  {
    [getTestimonialsAction]: (state, { payload }) => ({
      ...state,
      testimonials: payload,
    }),
    [getTestimonialTemplatesAction]: (state, { payload }) => ({
      ...state,
      testimonialTemplates: payload,
    }),
    [setLoaderTestimonial]: (state, { payload }) => ({
      ...state,
      testimonialLoader: payload,
    }),
  },
  initialState,
);

export default testimonialsReducer;
